/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import _ from 'lodash'
import React from 'react'
import { Router, Route, Redirect, Switch } from 'react-router-dom'
import MainContainer from '../container/MainContainer'
import LoginContainer from '../container/LoginContainer'
import PasswordResetContainer from '../container/user/PasswordResetContainer'
import PasswordResetUpdateContainer from '../container/user/PasswordResetUpdateContainer'
import SelfCheckInContainer from '../container/check_in/SelfCheckInContainer'
import SnackbarContainer from '../container/SnackbarContainer'
import history from '../util/history'
import routes from '../routes'
import r from '../util/Renderer'
import UserSession from '../core/UserSession'
import { dateToParam } from '../util/DateString'
import query from 'query-string'

const loginPath = '/'
const LoginRoute = ({ component: Component, ...rest }) => <Route {...rest} render={props => (rest.authenticated ? <AppRedirect /> : <LoginContainer {...props} />)} />

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (rest.authenticated ? <Component {...props} /> : <Redirect to={{ pathname: loginPath, state: { referrer: props.location } }} />)} />
)

function AppRedirect(props) {
  const parsed = query.parse(window.location.search)
  const redirect = _.propertyOf(parsed)('redirect')
  if (redirect) {
    return <Redirect to={redirect} />
  }
  // リダイレクト先がない場合の遷移先（通常ログイン時のトップページ）
  const date = dateToParam(new Date())
  return <Redirect to={`/receptionist/${date}`} />
}

function AppRoute(props) {
  const routes = props.routes
  const token = UserSession.read()
  const authenticated = token ? true : false

  return (
    <Switch>
      <Route path="/reset_password" exact component={PasswordResetContainer} />
      <Route path="/update_reset_password/:token" exact component={PasswordResetUpdateContainer} />
      <Route path="/check_in/:reservationId/:token" exact component={SelfCheckInContainer} />
      {routes.map((route, index) => (
        <PrivateRoute key={index} path={route.path} exact={route.exact} component={MainContainer} authenticated={authenticated} />
      ))}
      <LoginRoute path={loginPath} exact authenticated={authenticated} />
    </Switch>
  )
}

function AppView(props) {
  return (
    <Router history={history}>
      <div className="Container container-fluid">
        {r.renderIf(props.app.isLoading)(
          <div id="overlay">
            <div id="loader" />
          </div>
        )}
        <SnackbarContainer>{props}</SnackbarContainer>
        <AppRoute routes={routes}>{props}</AppRoute>
      </div>
    </Router>
  )
}
export default AppView
